import { render, staticRenderFns } from "./Forgot.vue?vue&type=template&id=910d850a&scoped=true&"
import script from "./Forgot.vue?vue&type=script&lang=ts&"
export * from "./Forgot.vue?vue&type=script&lang=ts&"
import style0 from "./Forgot.vue?vue&type=style&index=0&id=910d850a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "910d850a",
  null
  
)

export default component.exports